import React from 'react';
import classNames from 'classnames';
import { useController, ApplicationView as view } from '@aha-app/mvc';
import CardPreviewGroup from './CardPreviewGroup';
import CardFieldDropHandler from '../dnd/CardFieldDropHandler';
import ListSpacerDropTarget from 'javascripts/dnd/components/ListSpacerDropTarget';
import styles from './styles.mod.less';
import type UndraggableItem from 'javascripts/dnd/UndraggableItem';
import type CardLayoutEditorController from '../controllers/CardLayoutEditorController';
import { type CardRow } from 'components/framework/models';

type CardPreviewRowProps = {
  dragItem: UndraggableItem<CardRow>;
};

const CardPreviewRow: React.FC<CardPreviewRowProps> = ({ dragItem }) => {
  const row = dragItem.item;
  const controller = useController<CardLayoutEditorController>();

  if (row.divider) {
    return (
      <div className={styles.removableCardItem}>
        <aha-card-divider />
        <button
          className={classNames('btn-plain', styles.removeCardItem)}
          onClick={() => controller.actionRemoveDividerRow({ dividerRow: row })}
          title='Remove field'
        >
          <i className='fa-solid fa-square-xmark' />
        </button>
      </div>
    );
  }

  const { firstGroup, secondGroup } = row;

  const firstGroupDropHandler = new CardFieldDropHandler({
    controller,
    groupId: firstGroup.id,
    listKey: firstGroup.id,
  });
  const secondGroupDropHandler = new CardFieldDropHandler({
    controller,
    groupId: secondGroup.id,
    listKey: secondGroup.id,
  });

  return (
    <aha-card-row
      class={classNames({
        [styles.emptyRow]: row.empty,
      })}
    >
      <CardPreviewGroup group={firstGroup} />
      <ListSpacerDropTarget
        className={styles.groupSpacerDropTarget}
        dropHandler={firstGroupDropHandler}
        placeAtEnd
      />
      <ListSpacerDropTarget
        className={styles.groupSpacerDropTarget}
        dropHandler={secondGroupDropHandler}
      />
      <CardPreviewGroup group={secondGroup} />
    </aha-card-row>
  );
};

export default view(CardPreviewRow);
